import type { IDrawSubscriptionService, ISubscribeDrawUseCase } from '../../../domain/entry.js';

/**
 * Use case for subscribing to updates on a specific draw.
 *
 * @param drawSubscriptionService - The service to interact with draw subscriptions.
 * @returns Executor fn to subscribe to draw updates
 */
export function subscribeDrawUseCase(drawSubscriptionService: IDrawSubscriptionService): ISubscribeDrawUseCase {
  return {
    execute: ({ product, drawNumber, onUpdate }): ReturnType<ISubscribeDrawUseCase['execute']> => {
      const unsubscribe = drawSubscriptionService.subscribeDraw(product, { drawNumber }, onUpdate);

      return unsubscribe;
    },
  };
}
